// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sections{width:100%}.sections .product-section-headercontainer{padding-top:120px}@media screen and (min-width:767px){.sections .product-section-headercontainer{padding-top:0}}.sections .page-header{position:fixed}@media screen and (min-width:767px){.sections .page-header{position:relative;position:sticky;top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
